/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */ 
export const StyledRadioGroupTypes = {
    primary: "primary" as const
};

export type StyledRadioGroupTypes = typeof StyledRadioGroupTypes[keyof typeof StyledRadioGroupTypes];
